import { putRequest, putRequestMulitiPart } from "./NetworkService";

export const UpdateUserProfileService = async (
  endPoint: string,
  requestBody: any
) => {
  let { data }: { data: any } = await putRequestMulitiPart(endPoint, requestBody);
  return data;
};